import React, { useEffect, useState } from "react";
import { Box, IconButton } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import { applyCoupons, noCoupons, noCouponsMessage } from "./messages";
import CouponCode from "./CouponCode";
import DialogBox from "./dialog/Dialog";
import Text from "./text/Text";
import { promoCodeIcon } from "./images";

const CouponCodesList = (props) => {
  const {
    couponCodes,
    isCouponListOpen,
    setIsCouponListOpen,
    isFromBrowser,
    hasShownPopup,
    setHasShownPopup,
  } = props;

  const [sortedCoupons, setSortedCoupons] = useState([]);

  const browserStyles = isFromBrowser && {
    maxHeight: "668px",
    width: "442px",
  };

  const sortCouponCodes = () => {
    const eligibleCoupons = couponCodes?.filter(
      (couponCode) => couponCode.is_eligible
    );
    const unelegibleCoupons = couponCodes?.filter(
      (couponCode) => !couponCode.is_eligible
    );
    setSortedCoupons([...eligibleCoupons, ...unelegibleCoupons]);
  };

  useEffect(() => {
    sortCouponCodes();
  }, [couponCodes]);

  return (
    <DialogBox
      // fullScreen={false}
      showAppBar={!isFromBrowser}
      isOpenModal={isCouponListOpen}
      setIsOpenModal={setIsCouponListOpen}
      modalHeader={applyCoupons}
      directionToOpen="up"
      handleAction={() => setIsCouponListOpen(false)}
      PaperProps={{
        sx: {
          backgroundColor: "#F4F5FA",
        },
      }}
    >
      <Box className="coupon-code-list-dialog">
        {isFromBrowser && (
          <Box className="apply-coupon-heading">
            <Text
              size={18}
              className="default-text"
              font="semibold"
              sx={{ flex: 1 }}
            >
              {applyCoupons}
            </Text>
            <IconButton onClick={() => setIsCouponListOpen(false)}>
              <CloseIcon
                sx={{
                  color: "#848B9E",
                  height: "24px",
                  width: "24px",
                }}
              />
            </IconButton>
          </Box>
        )}
        {sortedCoupons?.length === 0 ? (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            height="100%"
            gap={3}
            padding="36px 24px"
          >
            <img src={promoCodeIcon} height={54} width={54} />
            <Text font="bold" size={20}>
              {noCoupons}
            </Text>
            <Text font="regular" size={14} color="#848B9E">
              {noCouponsMessage}
            </Text>
          </Box>
        ) : (
          <Box
            className="coupon-codes-container"
            height={isFromBrowser ? "608px" : "100%"}
          >
            {sortedCoupons?.map((couponCode) => (
              <CouponCode couponCode={couponCode} {...props} />
            ))}
          </Box>
        )}
      </Box>
    </DialogBox>
  );
};

export default CouponCodesList;
